import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from './ProductOptionPicker';
import { Shopify } from '@eastsideco/salvo-ts/lib/generated/shopify-types';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref({ required: false }) first!: HTMLDivElement;
    private imageHold: Shopify.Liquid.Image | null = null;

    init() {
        const productOptionPicker = document.querySelector('#product-form-option-picker');

        if (productOptionPicker && productOptionPicker.tagName === 'PRODUCT-OPTION-PICKER') {
            const productOptionPickerComponent = productOptionPicker as ProductOptionPicker;

            // eslint-disable-next-line max-len
            this.$subscribe(productOptionPickerComponent.onSelectedVariantChange, (variant: Shopify.Liquid.Variant | null) => {
                let image = null;
                if (variant?.featured_image) {
                    image = variant?.featured_image;
                }
                this.imageHold = image;
                this.handleOnVariantchange(variant, image);
            });
        }
    }
    handleOnVariantchange(variant: Shopify.Liquid.Variant | null, image: Shopify.Liquid.Image | null) {
        if (!image || !this.first) { return; }

        const img = this.first.querySelector('img');
        if (!img) { return; }
        img.setAttribute('src', image?.src);
        img.setAttribute('height', image?.height.toString());
        img.setAttribute('width', image?.width.toString());
        img.setAttribute('alt', image?.alt ? image.alt : '');
    }
    setHoldImage() {
        const img = this.first?.querySelector('img');
        if (!img || !this.imageHold) { return; }
        img.setAttribute('src', this.imageHold.src);
        img.setAttribute('height', this.imageHold.height.toString());
        img.setAttribute('width', this.imageHold.width.toString());
        img.setAttribute('alt', this.imageHold.alt ? this.imageHold.alt : '');
    }

}
